import type { NearbyStorageSpots } from "@/libs/bounce/stores/types"

export const getNearbyStorageSpotsWithTranslations = <
  T extends {
    city: Pick<NearbyStorageSpots[number]["city"], "name" | "translations">
    pois: NearbyStorageSpots[number]["pois"]
  },
>(
  edges: Array<{ node: T }>,
) => {
  return edges.map(({ node }) => ({
    node: {
      ...node,
      city: {
        ...node.city,
        translatedName: node.city.translations.name,
      },
      pois: node.pois?.map(poi => ({ ...poi, translatedName: poi.translations.name })) ?? null,
    },
  }))
}

export const getNearbyStorageSpotsNodesWithTranslations = (nodes: Array<any>): Array<any> => {
  return nodes.map(node => ({
    ...node,
    city: {
      ...node.city,
      translatedName: node.city.translations.name,
    },
    pois: node.pois?.map((poi: any) => ({ ...poi, translatedName: poi.translations.name })) ?? null,
  }))
}
